import axios from 'axios';

export default {
    namespaced: true,
    state: {
        pressCosts: [],
        pressSleeves: [],
    },
    getters: {
        getAllCosts(state) {
            return state.pressCosts;
        },
        getAllSleeves(state) {
            return state.pressSleeves;
        },
    },
    actions: {
        index({commit}) {
            return axios.all([
                axios.get(process.env.VUE_APP_API_URL + 'press_costs')
                    .then(({data}) => {
                        commit('setPressCosts', data);
                    }),
                axios.get(process.env.VUE_APP_API_URL + 'press_sleeves')
                    .then(({data}) => {
                        commit('setPressSleeves', data);
                    }),
            ]);
        },
    },
    mutations: {
        setPressCosts(state, costs) {
            state.pressCosts = costs;
        },
        setPressSleeves(state, sleeves) {
            state.pressSleeves = sleeves;
        },
    },
};
